export default "__VITE_ASSET__B4c9ku2l__"